<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
      <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange" style="width: 360px;" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      <input-select selectTitle="摄像机通道" :selectKey="'channelId'" :selectData="fixTypeList"  @search="search" style="margin-left:20px"/>
      </div>
    </div>

    <div class="background">
      <div class="box" v-for="item in tableData">
        <div class="information">
          <div class="photo">
            <img :src="item.picUrl" alt="" class="photo2">
          </div>
          <div class="person">
            <div>
              <span>年龄：</span>
              <span>{{item.age}}</span>
            </div>
            <div class="gender">
              <span>性别：</span>
              <span>{{item.genderText}}</span>
            </div>
            <div>
              <span>口罩：</span>
              <span>{{item.isFacemaskText}}</span>
            </div>
          </div>
        </div>
        <div class="position">
          <div>{{item.channelId}}</div>
          <div>{{item.time}}</div>
        </div>
      </div>
    </div>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top:15px"
      :page-sizes="[12, 20, 50, 100]"
      :current-page="requestData.pageNum"
      :page-size="requestData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "monitor-point-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "人脸检测"
        }
      ],
      fixTypeList:[
        {label:"全部",key:""},
        {label:"1",key:"1"},
        {label:"2",key:"2"}
      ],
      requestData: {
        searchKey: "",
        pageSize: 12,
        pageNum: 1,
        startTime: "",
        endTime: ""
      },
      uploadUrl: "",
      total: 0,
      timevalue: [],
      tableData: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreateTime();
    // this.getFacePointList();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getFaceRecordPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            if (v.gender == "1") {
              v.genderText = "男";
            } else {
              v.genderText = "女";
            }
            if (v.isFacemask) {
              v.isFacemaskText = "有";
            } else {
              v.isFacemaskText = "无";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取监测点列表失败"));
    },
    getFacePointList() {
      this.$axios
        .post(api.getFacePointList, {})
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.key = v.deviceCode;
            v.label = v.name;
          });
          data.unshift({ key: "", label: "全部" });
          this.fixTypeList = data;
        })
        .catch(errorHandler("获取摄像机列表失败"));
    },

    handleSizeChange(val) {
      this.requestData.pageSize = val;
      this.getPage();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getPage();
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>

<style scoped lang="less">
.background {
  display: flex;
  flex-wrap: wrap;
}
.box {
  width: 286px;
  height: 230px;
  background-color: #eff2ff;
  border: 1px solid #e9e9eb;
  border-radius: 8px;
  margin: 10px 20px;
}
.information {
  height: 85%;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.photo {
  width: 110px;
  height: 141px;
}
.photo2 {
  width: 110px;
  height: 141px;
  border-radius: 8px;
}
.person {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.gender {
  margin: 20px 0;
}
.position {
  height: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/FaceDetection/FaceDetection.vue